import React from 'react'
// Components
import { Modal } from 'components/Modal/Modal'
// Styles
import {
	ModalTemplateTitle,
	ModalTemplateIcon,
} from './ModalTemplate.styled'
import { ModalTemplateProps } from './ModalTemplate.props'

export const ModalTemplate = ({
	title,
	icon,
	showClose,
	children,
	containerStyle,
	onClose,
}: ModalTemplateProps) => {

	return (
		<Modal
			containerStyle={containerStyle}
			showClose={showClose}
			onClose={onClose}
		>
			{icon && <ModalTemplateIcon src={icon} alt="" />}
			<ModalTemplateTitle>{title}</ModalTemplateTitle>
			{children}
		</Modal>
	)
}